export const toTimezoneAbbrev = (tName: string) => timeZones.find((t) => t.name.toLowerCase() === tName.toLowerCase())?.abbreviation ?? ''

export const toTimezoneName = (tAbbrev: string) => timeZones.find((t) => t.abbreviation.toLowerCase() === tAbbrev.toLowerCase())?.name ?? ''

type timeZoneItem = {
  abbreviation: string
  name: string
  offset: string
}

export const timeZones: timeZoneItem[] = [
  {
    abbreviation: 'A',
    name: 'Alpha Time Zone',
    offset: '+1',
  },
  {
    abbreviation: 'ACDT',
    name: 'Australian Central Daylight Time',
    offset: '+10:30',
  },
  {
    abbreviation: 'ACST',
    name: 'Australian Central Standard Time',
    offset: '+9:30',
  },
  {
    abbreviation: 'ACT',
    name: 'Acre Time',
    offset: '-5',
  },
  {
    abbreviation: 'ACT',
    name: 'Australian Central Time',
    offset: '+9:30 / +10:30',
  },
  {
    abbreviation: 'ACWST',
    name: 'Australian Central Western Standard Time',
    offset: '+8:45',
  },
  {
    abbreviation: 'ADT',
    name: 'Arabia Daylight Time',
    offset: '+4',
  },
  {
    abbreviation: 'ADT',
    name: 'Atlantic Daylight Time',
    offset: '-3',
  },
  {
    abbreviation: 'AEDT',
    name: 'Australian Eastern Daylight Time',
    offset: '+11',
  },
  {
    abbreviation: 'AEST',
    name: 'Australian Eastern Standard Time',
    offset: '+10',
  },
  {
    abbreviation: 'AET',
    name: 'Australian Eastern Time',
    offset: '+10:00 / +11:00',
  },
  {
    abbreviation: 'AFT',
    name: 'Afghanistan Time',
    offset: '+4:30',
  },
  {
    abbreviation: 'AKDT',
    name: 'Alaska Daylight Time',
    offset: '-8',
  },
  {
    abbreviation: 'AKST',
    name: 'Alaska Standard Time',
    offset: '-9',
  },
  {
    abbreviation: 'ALMT',
    name: 'Alma-Ata Time',
    offset: '+6',
  },
  {
    abbreviation: 'AMST',
    name: 'Amazon Summer Time',
    offset: '-3',
  },
  {
    abbreviation: 'AMST',
    name: 'Armenia Summer Time',
    offset: '+5',
  },
  {
    abbreviation: 'AMT',
    name: 'Amazon Time',
    offset: '-4',
  },
  {
    abbreviation: 'AMT',
    name: 'Armenia Time',
    offset: '+4',
  },
  {
    abbreviation: 'ANAST',
    name: 'Anadyr Summer Time',
    offset: '+12',
  },
  {
    abbreviation: 'ANAT',
    name: 'Anadyr Time',
    offset: '+12',
  },
  {
    abbreviation: 'AQTT',
    name: 'Aqtobe Time',
    offset: '+5',
  },
  {
    abbreviation: 'ART',
    name: 'Argentina Time',
    offset: '-3',
  },
  {
    abbreviation: 'AST',
    name: 'Arabia Standard Time',
    offset: '+3',
  },
  {
    abbreviation: 'AST',
    name: 'Atlantic Standard Time',
    offset: '-4',
  },
  {
    abbreviation: 'AT',
    name: 'Atlantic Time',
    offset: '-4:00 / -3:00',
  },
  {
    abbreviation: 'AWDT',
    name: 'Australian Western Daylight Time',
    offset: '+9',
  },
  {
    abbreviation: 'AWST',
    name: 'Australian Western Standard Time',
    offset: '+8',
  },
  {
    abbreviation: 'AZOST',
    name: 'Azores Summer Time',
    offset: '+0',
  },
  {
    abbreviation: 'AZOT',
    name: 'Azores Time',
    offset: '-1',
  },
  {
    abbreviation: 'AZST',
    name: 'Azerbaijan Summer Time',
    offset: '+5',
  },
  {
    abbreviation: 'AZT',
    name: 'Azerbaijan Time',
    offset: '+4',
  },
  {
    abbreviation: 'AoE',
    name: 'Anywhere on Earth',
    offset: '-12',
  },
  {
    abbreviation: 'B',
    name: 'Bravo Time Zone',
    offset: '+2',
  },
  {
    abbreviation: 'BNT',
    name: 'Brunei Darussalam Time',
    offset: '+8',
  },
  {
    abbreviation: 'BOT',
    name: 'Bolivia Time',
    offset: '-4',
  },
  {
    abbreviation: 'BRST',
    name: 'Brasília Summer Time',
    offset: '-2',
  },
  {
    abbreviation: 'BRT',
    name: 'Brasília Time',
    offset: '-3',
  },
  {
    abbreviation: 'BST',
    name: 'Bangladesh Standard Time',
    offset: '+6',
  },
  {
    abbreviation: 'BST',
    name: 'Bougainville Standard Time',
    offset: '+11',
  },
  {
    abbreviation: 'BST',
    name: 'British Summer Time',
    offset: '+1',
  },
  {
    abbreviation: 'BTT',
    name: 'Bhutan Time',
    offset: '+6',
  },
  {
    abbreviation: 'C',
    name: 'Charlie Time Zone',
    offset: '+3',
  },
  {
    abbreviation: 'CAST',
    name: 'Casey Time',
    offset: '+8',
  },
  {
    abbreviation: 'CAT',
    name: 'Central Africa Time',
    offset: '+2',
  },
  {
    abbreviation: 'CCT',
    name: 'Cocos Islands Time',
    offset: '+6:30',
  },
  {
    abbreviation: 'CDT',
    name: 'Central Daylight Time',
    offset: '-5',
  },
  {
    abbreviation: 'CDT',
    name: 'Cuba Daylight Time',
    offset: '-4',
  },
  {
    abbreviation: 'CEST',
    name: 'Central European Summer Time',
    offset: '+2',
  },
  {
    abbreviation: 'CET',
    name: 'Central European Time',
    offset: '+1',
  },
  {
    abbreviation: 'CHADT',
    name: 'Chatham Island Daylight Time',
    offset: '+13:45',
  },
  {
    abbreviation: 'CHAST',
    name: 'Chatham Island Standard Time',
    offset: '+12:45',
  },
  {
    abbreviation: 'CHOST',
    name: 'Choibalsan Summer Time',
    offset: '+9',
  },
  {
    abbreviation: 'CHOT',
    name: 'Choibalsan Time',
    offset: '+8',
  },
  {
    abbreviation: 'CHUT',
    name: 'Chuuk Time',
    offset: '+10',
  },
  {
    abbreviation: 'CIDST',
    name: 'Cayman Islands Daylight Saving Time',
    offset: '-4',
  },
  {
    abbreviation: 'CIST',
    name: 'Cayman Islands Standard Time',
    offset: '-5',
  },
  {
    abbreviation: 'CKT',
    name: 'Cook Island Time',
    offset: '-10',
  },
  {
    abbreviation: 'CLST',
    name: 'Chile Summer Time',
    offset: '-3',
  },
  {
    abbreviation: 'CLT',
    name: 'Chile Standard Time',
    offset: '-4',
  },
  {
    abbreviation: 'COT',
    name: 'Colombia Time',
    offset: '-5',
  },
  {
    abbreviation: 'CST',
    name: 'Central Standard Time',
    offset: '-6',
  },
  {
    abbreviation: 'CST',
    name: 'China Standard Time',
    offset: '+8',
  },
  {
    abbreviation: 'CST',
    name: 'Cuba Standard Time',
    offset: '-5',
  },
  {
    abbreviation: 'CT',
    name: 'Central Time',
    offset: '-6:00 / -5:00',
  },
  {
    abbreviation: 'CVT',
    name: 'Cape Verde Time',
    offset: '-1',
  },
  {
    abbreviation: 'CXT',
    name: 'Christmas Island Time',
    offset: '+7',
  },
  {
    abbreviation: 'ChST',
    name: 'Chamorro Standard Time',
    offset: '+10',
  },
  {
    abbreviation: 'D',
    name: 'Delta Time Zone',
    offset: '+4',
  },
  {
    abbreviation: 'DAVT',
    name: 'Davis Time',
    offset: '+7',
  },
  {
    abbreviation: 'DDUT',
    name: "Dumont-d'Urville Time",
    offset: '+10',
  },
  {
    abbreviation: 'E',
    name: 'Echo Time Zone',
    offset: '+5',
  },
  {
    abbreviation: 'EASST',
    name: 'Easter Island Summer Time',
    offset: '-5',
  },
  {
    abbreviation: 'EAST',
    name: 'Easter Island Standard Time',
    offset: '-6',
  },
  {
    abbreviation: 'EAT',
    name: 'Eastern Africa Time',
    offset: '+3',
  },
  {
    abbreviation: 'ECT',
    name: 'Ecuador Time',
    offset: '-5',
  },
  {
    abbreviation: 'EDT',
    name: 'Eastern Daylight Time',
    offset: '-4',
  },
  {
    abbreviation: 'EEST',
    name: 'Eastern European Summer Time',
    offset: '+3',
  },
  {
    abbreviation: 'EET',
    name: 'Eastern European Time',
    offset: '+2',
  },
  {
    abbreviation: 'EGST',
    name: 'Eastern Greenland Summer Time',
    offset: '+0',
  },
  {
    abbreviation: 'EGT',
    name: 'East Greenland Time',
    offset: '-1',
  },
  {
    abbreviation: 'EST',
    name: 'Eastern Standard Time',
    offset: '-5',
  },
  {
    abbreviation: 'ET',
    name: 'Eastern Time',
    offset: '-5:00 / -4:00',
  },
  {
    abbreviation: 'F',
    name: 'Foxtrot Time Zone',
    offset: '+6',
  },
  {
    abbreviation: 'FET',
    name: 'Further-Eastern European Time',
    offset: '+3',
  },
  {
    abbreviation: 'FJST',
    name: 'Fiji Summer Time',
    offset: '+13',
  },
  {
    abbreviation: 'FJT',
    name: 'Fiji Time',
    offset: '+12',
  },
  {
    abbreviation: 'FKST',
    name: 'Falkland Islands Summer Time',
    offset: '-3',
  },
  {
    abbreviation: 'FKT',
    name: 'Falkland Island Time',
    offset: '-4',
  },
  {
    abbreviation: 'FNT',
    name: 'Fernando de Noronha Time',
    offset: '-2',
  },
  {
    abbreviation: 'G',
    name: 'Golf Time Zone',
    offset: '+7',
  },
  {
    abbreviation: 'GALT',
    name: 'Galapagos Time',
    offset: '-6',
  },
  {
    abbreviation: 'GAMT',
    name: 'Gambier Time',
    offset: '-9',
  },
  {
    abbreviation: 'GET',
    name: 'Georgia Standard Time',
    offset: '+4',
  },
  {
    abbreviation: 'GFT',
    name: 'French Guiana Time',
    offset: '-3',
  },
  {
    abbreviation: 'GILT',
    name: 'Gilbert Island Time',
    offset: '+12',
  },
  {
    abbreviation: 'GMT',
    name: 'Greenwich Mean Time',
    offset: '+0',
  },
  {
    abbreviation: 'GMT',
    name: 'GMT Standard Time',
    offset: '+0',
  },
  {
    abbreviation: 'GST',
    name: 'Gulf Standard Time',
    offset: '+4',
  },
  {
    abbreviation: 'GST',
    name: 'South Georgia Time',
    offset: '-2',
  },
  {
    abbreviation: 'GYT',
    name: 'Guyana Time',
    offset: '-4',
  },
  {
    abbreviation: 'H',
    name: 'Hotel Time Zone',
    offset: '+8',
  },
  {
    abbreviation: 'HDT',
    name: 'Hawaii-Aleutian Daylight Time',
    offset: '-9',
  },
  {
    abbreviation: 'HKT',
    name: 'Hong Kong Time',
    offset: '+8',
  },
  {
    abbreviation: 'HOVST',
    name: 'Hovd Summer Time',
    offset: '+8',
  },
  {
    abbreviation: 'HOVT',
    name: 'Hovd Time',
    offset: '+7',
  },
  {
    abbreviation: 'HST',
    name: 'Hawaii Standard Time',
    offset: '-10',
  },
  {
    abbreviation: 'I',
    name: 'India Time Zone',
    offset: '+9',
  },
  {
    abbreviation: 'ICT',
    name: 'Indochina Time',
    offset: '+7',
  },
  {
    abbreviation: 'IDT',
    name: 'Israel Daylight Time',
    offset: '+3',
  },
  {
    abbreviation: 'IOT',
    name: 'Indian Chagos Time',
    offset: '+6',
  },
  {
    abbreviation: 'IRDT',
    name: 'Iran Daylight Time',
    offset: '+4:30',
  },
  {
    abbreviation: 'IRKST',
    name: 'Irkutsk Summer Time',
    offset: '+9',
  },
  {
    abbreviation: 'IRKT',
    name: 'Irkutsk Time',
    offset: '+8',
  },
  {
    abbreviation: 'IRST',
    name: 'Iran Standard Time',
    offset: '+3:30',
  },
  {
    abbreviation: 'IST',
    name: 'India Standard Time',
    offset: '+5:30',
  },
  {
    abbreviation: 'IST',
    name: 'Irish Standard Time',
    offset: '+1',
  },
  {
    abbreviation: 'IST',
    name: 'Israel Standard Time',
    offset: '+2',
  },
  {
    abbreviation: 'JST',
    name: 'Japan Standard Time',
    offset: '+9',
  },
  {
    abbreviation: 'K',
    name: 'Kilo Time Zone',
    offset: '+10',
  },
  {
    abbreviation: 'KGT',
    name: 'Kyrgyzstan Time',
    offset: '+6',
  },
  {
    abbreviation: 'KOST',
    name: 'Kosrae Time',
    offset: '+11',
  },
  {
    abbreviation: 'KRAST',
    name: 'Krasnoyarsk Summer Time',
    offset: '+8',
  },
  {
    abbreviation: 'KRAT',
    name: 'Krasnoyarsk Time',
    offset: '+7',
  },
  {
    abbreviation: 'KST',
    name: 'Korea Standard Time',
    offset: '+9',
  },
  {
    abbreviation: 'KUYT',
    name: 'Kuybyshev Time',
    offset: '+4',
  },
  {
    abbreviation: 'L',
    name: 'Lima Time Zone',
    offset: '+11',
  },
  {
    abbreviation: 'LHDT',
    name: 'Lord Howe Daylight Time',
    offset: '+11',
  },
  {
    abbreviation: 'LHST',
    name: 'Lord Howe Standard Time',
    offset: '+10:30',
  },
  {
    abbreviation: 'LINT',
    name: 'Line Islands Time',
    offset: '+14',
  },
  {
    abbreviation: 'M',
    name: 'Mike Time Zone',
    offset: '+12',
  },
  {
    abbreviation: 'MAGST',
    name: 'Magadan Summer Time',
    offset: '+12',
  },
  {
    abbreviation: 'MAGT',
    name: 'Magadan Time',
    offset: '+11',
  },
  {
    abbreviation: 'MART',
    name: 'Marquesas Time',
    offset: '-9:30',
  },
  {
    abbreviation: 'MAWT',
    name: 'Mawson Time',
    offset: '+5',
  },
  {
    abbreviation: 'MDT',
    name: 'Mountain Daylight Time',
    offset: '-6',
  },
  {
    abbreviation: 'MHT',
    name: 'Marshall Islands Time',
    offset: '+12',
  },
  {
    abbreviation: 'MMT',
    name: 'Myanmar Time',
    offset: '+6:30',
  },
  {
    abbreviation: 'MSD',
    name: 'Moscow Daylight Time',
    offset: '+4',
  },
  {
    abbreviation: 'MSK',
    name: 'Moscow Standard Time',
    offset: '+3',
  },
  {
    abbreviation: 'MST',
    name: 'Mountain Standard Time',
    offset: '-7',
  },
  {
    abbreviation: 'MT',
    name: 'Mountain Time',
    offset: '-7:00 / -6:00',
  },
  {
    abbreviation: 'MUT',
    name: 'Mauritius Time',
    offset: '+4',
  },
  {
    abbreviation: 'MVT',
    name: 'Maldives Time',
    offset: '+5',
  },
  {
    abbreviation: 'MYT',
    name: 'Malaysia Time',
    offset: '+8',
  },
  {
    abbreviation: 'N',
    name: 'November Time Zone',
    offset: '-1',
  },
  {
    abbreviation: 'NCT',
    name: 'New Caledonia Time',
    offset: '+11',
  },
  {
    abbreviation: 'NDT',
    name: 'Newfoundland Daylight Time',
    offset: '-2:30',
  },
  {
    abbreviation: 'NFDT',
    name: 'Norfolk Daylight Time',
    offset: '+12',
  },
  {
    abbreviation: 'NFT',
    name: 'Norfolk Time',
    offset: '+11',
  },
  {
    abbreviation: 'NOVST',
    name: 'Novosibirsk Summer Time',
    offset: '+7',
  },
  {
    abbreviation: 'NOVT',
    name: 'Novosibirsk Time',
    offset: '+7',
  },
  {
    abbreviation: 'NPT',
    name: 'Nepal Time',
    offset: '+5:45',
  },
  {
    abbreviation: 'NRT',
    name: 'Nauru Time',
    offset: '+12',
  },
  {
    abbreviation: 'NST',
    name: 'Newfoundland Standard Time',
    offset: '-3:30',
  },
  {
    abbreviation: 'NUT',
    name: 'Niue Time',
    offset: '-11',
  },
  {
    abbreviation: 'NZDT',
    name: 'New Zealand Daylight Time',
    offset: '+13',
  },
  {
    abbreviation: 'NZST',
    name: 'New Zealand Standard Time',
    offset: '+12',
  },
  {
    abbreviation: 'O',
    name: 'Oscar Time Zone',
    offset: '-2',
  },
  {
    abbreviation: 'OMSST',
    name: 'Omsk Summer Time',
    offset: '+7',
  },
  {
    abbreviation: 'OMST',
    name: 'Omsk Standard Time',
    offset: '+6',
  },
  {
    abbreviation: 'ORAT',
    name: 'Oral Time',
    offset: '+5',
  },
  {
    abbreviation: 'P',
    name: 'Papa Time Zone',
    offset: '-3',
  },
  {
    abbreviation: 'PDT',
    name: 'Pacific Daylight Time',
    offset: '-7',
  },
  {
    abbreviation: 'PET',
    name: 'Peru Time',
    offset: '-5',
  },
  {
    abbreviation: 'PETST',
    name: 'Kamchatka Summer Time',
    offset: '+12',
  },
  {
    abbreviation: 'PETT',
    name: 'Kamchatka Time',
    offset: '+12',
  },
  {
    abbreviation: 'PGT',
    name: 'Papua New Guinea Time',
    offset: '+10',
  },
  {
    abbreviation: 'PHOT',
    name: 'Phoenix Island Time',
    offset: '+13',
  },
  {
    abbreviation: 'PHT',
    name: 'Philippine Time',
    offset: '+8',
  },
  {
    abbreviation: 'PKT',
    name: 'Pakistan Standard Time',
    offset: '+5',
  },
  {
    abbreviation: 'PMDT',
    name: 'Pierre &amp; Miquelon Daylight Time',
    offset: '-2',
  },
  {
    abbreviation: 'PMST',
    name: 'Pierre &amp; Miquelon Standard Time',
    offset: '-3',
  },
  {
    abbreviation: 'PONT',
    name: 'Pohnpei Standard Time',
    offset: '+11',
  },
  {
    abbreviation: 'PST',
    name: 'Pacific Standard Time',
    offset: '-8',
  },
  {
    abbreviation: 'PST',
    name: 'Pitcairn Standard Time',
    offset: '-8',
  },
  {
    abbreviation: 'PT',
    name: 'Pacific Time',
    offset: '-8:00 / -7:00',
  },
  {
    abbreviation: 'PWT',
    name: 'Palau Time',
    offset: '+9',
  },
  {
    abbreviation: 'PYST',
    name: 'Paraguay Summer Time',
    offset: '-3',
  },
  {
    abbreviation: 'PYT',
    name: 'Paraguay Time',
    offset: '-4',
  },
  {
    abbreviation: 'PYT',
    name: 'Pyongyang Time',
    offset: '+8:30',
  },
  {
    abbreviation: 'Q',
    name: 'Quebec Time Zone',
    offset: '-4',
  },
  {
    abbreviation: 'QYZT',
    name: 'Qyzylorda Time',
    offset: '+6',
  },
  {
    abbreviation: 'R',
    name: 'Romeo Time Zone',
    offset: '-5',
  },
  {
    abbreviation: 'RET',
    name: 'Reunion Time',
    offset: '+4',
  },
  {
    abbreviation: 'ROTT',
    name: 'Rothera Time',
    offset: '-3',
  },
  {
    abbreviation: 'S',
    name: 'Sierra Time Zone',
    offset: '-6',
  },
  {
    abbreviation: 'SAKT',
    name: 'Sakhalin Time',
    offset: '+11',
  },
  {
    abbreviation: 'SAMT',
    name: 'Samara Time',
    offset: '+4',
  },
  {
    abbreviation: 'SAST',
    name: 'South Africa Standard Time',
    offset: '+2',
  },
  {
    abbreviation: 'SBT',
    name: 'Solomon Islands Time',
    offset: '+11',
  },
  {
    abbreviation: 'SCT',
    name: 'Seychelles Time',
    offset: '+4',
  },
  {
    abbreviation: 'SGT',
    name: 'Singapore Time',
    offset: '+8',
  },
  {
    abbreviation: 'SRET',
    name: 'Srednekolymsk Time',
    offset: '+11',
  },
  {
    abbreviation: 'SRT',
    name: 'Suriname Time',
    offset: '-3',
  },
  {
    abbreviation: 'SST',
    name: 'Samoa Standard Time',
    offset: '-11',
  },
  {
    abbreviation: 'SYOT',
    name: 'Syowa Time',
    offset: '+3',
  },
  {
    abbreviation: 'T',
    name: 'Tango Time Zone',
    offset: '-7',
  },
  {
    abbreviation: 'TAHT',
    name: 'Tahiti Time',
    offset: '-10',
  },
  {
    abbreviation: 'TFT',
    name: 'French Southern and Antarctic Time',
    offset: '+5',
  },
  {
    abbreviation: 'TJT',
    name: 'Tajikistan Time',
    offset: '+5',
  },
  {
    abbreviation: 'TKT',
    name: 'Tokelau Time',
    offset: '+13',
  },
  {
    abbreviation: 'TLT',
    name: 'East Timor Time',
    offset: '+9',
  },
  {
    abbreviation: 'TMT',
    name: 'Turkmenistan Time',
    offset: '+5',
  },
  {
    abbreviation: 'TOST',
    name: 'Tonga Summer Time',
    offset: '+14',
  },
  {
    abbreviation: 'TOT',
    name: 'Tonga Time',
    offset: '+13',
  },
  {
    abbreviation: 'TRT',
    name: 'Turkey Time',
    offset: '+3',
  },
  {
    abbreviation: 'TVT',
    name: 'Tuvalu Time',
    offset: '+12',
  },
  {
    abbreviation: 'U',
    name: 'Uniform Time Zone',
    offset: '-8',
  },
  {
    abbreviation: 'ULAST',
    name: 'Ulaanbaatar Summer Time',
    offset: '+9',
  },
  {
    abbreviation: 'ULAT',
    name: 'Ulaanbaatar Time',
    offset: '+8',
  },
  {
    abbreviation: 'UTC',
    name: 'Coordinated Universal Time',
    offset: 'UTC',
  },
  {
    abbreviation: 'UYST',
    name: 'Uruguay Summer Time',
    offset: '-2',
  },
  {
    abbreviation: 'UYT',
    name: 'Uruguay Time',
    offset: '-3',
  },
  {
    abbreviation: 'UZT',
    name: 'Uzbekistan Time',
    offset: '+5',
  },
  {
    abbreviation: 'V',
    name: 'Victor Time Zone',
    offset: '-9',
  },
  {
    abbreviation: 'VET',
    name: 'Venezuelan Standard Time',
    offset: '-4',
  },
  {
    abbreviation: 'VLAST',
    name: 'Vladivostok Summer Time',
    offset: '+11',
  },
  {
    abbreviation: 'VLAT',
    name: 'Vladivostok Time',
    offset: '+10',
  },
  {
    abbreviation: 'VOST',
    name: 'Vostok Time',
    offset: '+6',
  },
  {
    abbreviation: 'VUT',
    name: 'Vanuatu Time',
    offset: '+11',
  },
  {
    abbreviation: 'W',
    name: 'Whiskey Time Zone',
    offset: '-10',
  },
  {
    abbreviation: 'WAKT',
    name: 'Wake Time',
    offset: '+12',
  },
  {
    abbreviation: 'WARST',
    name: 'Western Argentine Summer Time',
    offset: '-3',
  },
  {
    abbreviation: 'WAST',
    name: 'West Africa Summer Time',
    offset: '+2',
  },
  {
    abbreviation: 'WAT',
    name: 'West Africa Time',
    offset: '+1',
  },
  {
    abbreviation: 'WEST',
    name: 'Western European Summer Time',
    offset: '+1',
  },
  {
    abbreviation: 'WET',
    name: 'Western European Time',
    offset: '+0',
  },
  {
    abbreviation: 'WFT',
    name: 'Wallis and Futuna Time',
    offset: '+12',
  },
  {
    abbreviation: 'WGST',
    name: 'Western Greenland Summer Time',
    offset: '-2',
  },
  {
    abbreviation: 'WGT',
    name: 'West Greenland Time',
    offset: '-3',
  },
  {
    abbreviation: 'WIB',
    name: 'Western Indonesian Time',
    offset: '+7',
  },
  {
    abbreviation: 'WIT',
    name: 'Eastern Indonesian Time',
    offset: '+9',
  },
  {
    abbreviation: 'WITA',
    name: 'Central Indonesian Time',
    offset: '+8',
  },
  {
    abbreviation: 'WST',
    name: 'West Samoa Time',
    offset: '+13',
  },
  {
    abbreviation: 'WST',
    name: 'Western Sahara Summer Time',
    offset: '+1',
  },
  {
    abbreviation: 'WT',
    name: 'Western Sahara Standard Time',
    offset: '+0',
  },
  {
    abbreviation: 'X',
    name: 'X-ray Time Zone',
    offset: '-11',
  },
  {
    abbreviation: 'Y',
    name: 'Yankee Time Zone',
    offset: '-12',
  },
  {
    abbreviation: 'YAKST',
    name: 'Yakutsk Summer Time',
    offset: '+10',
  },
  {
    abbreviation: 'YAKT',
    name: 'Yakutsk Time',
    offset: '+9',
  },
  {
    abbreviation: 'YAPT',
    name: 'Yap Time',
    offset: '+10',
  },
  {
    abbreviation: 'YEKST',
    name: 'Yekaterinburg Summer Time',
    offset: '+6',
  },
  {
    abbreviation: 'YEKT',
    name: 'Yekaterinburg Time',
    offset: '+5',
  },
  {
    abbreviation: 'Z',
    name: 'Zulu Time Zone',
    offset: '+0',
  },
]